import Logo from '../assets/static/logo.png'
import AuthBg from '../assets/static/authbg.jpg'
import About from '../assets/static/about.png'
import Contact from '../assets/static/contact.png'
import FourOFour from '../assets/static/404.png'
import FakeUser from '../assets/static/vector.jpg'
import DoctorVector from '../assets/static/doctor-vector.png'
import PatientVector from '../assets/static/patient-vector.png'
import PendingApproval from '../assets/static/pending.png'
import Loading from '../assets/static/loader.gif'
import Unlock from '../assets/static/unlock.png'
import PeopleSearch from '../assets/static/people_search.png'
import Service from '../assets/static/service.png'
import Doctor from '../assets/static/doctor.jpg'

export const Images = {
    Logo,
    AuthBg,
    About,
    Contact,
    FourOFour,
    FakeUser,
    DoctorVector,
    PatientVector,
    PendingApproval,
    Loading,
    Unlock,
    PeopleSearch,
    Service,
    Doctor
} 